import { OrganizationUnitsFormType } from 'components';

export const updateOrganizationUnitInitialValues: Partial<OrganizationUnitsFormType> = {};
